import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {HTHWinConfig} from "../configs/HTHWinConfig";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHGameMode} from "../server/HTHGameMode";

export class HTHTotalWinCountupPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return !HTH.model.brokeTheBank && !HTH.model.isBigWin && (HTH.model.mode.includes("FREESPIN") ? HTH.model.gameData.spinWin > 0
                : HTH.model.gameData.accumulatedRoundWin > 0) && !HTH.model.isNextAvalanche && HTH.model.isCurrentAvalanche && !HTH.model.isGodModeMaxWin
            && !HTH.model.isExtraSpinEndingAuto;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                HTH.screenInteractive.setInteractiveState(false);
            }
        });
        const isWinBelowStake: boolean = HTHHelper.isWinBelowStake();
        const checkHideCondition: boolean = (HTH.model.mode.includes("NORMAL") && HTH.model.nextMode === HTHGameMode.FREESPIN) || (!HTH.model.mode.includes("NORMAL") && ((HTH.model.nextMode === HTHGameMode.FREESPIN && HTH.model.isScatterPresent) || HTH.model.nextMode === HTHGameMode.EXTRA_SPIN || HTH.model.nextMode === HTHGameMode.NORMAL));

        HTH.screenInteractive.setInteractiveState(false);
        if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            tl.timeScale(1.4);
        }
        if (HTHGameConfig.isSkipped[0]) {
           // console.log("already at 2x or 4x speed totalwincountuppresentation");
            tl.seek("countupCompleted", false);
        } else {
            controller.setSkipCallback(() => {
             //   console.log("first skip totalwincountuppresentation")
                tl.seek("countupCompleted", false);
            })
        }
        if (!isWinBelowStake) {
            tl.add(HTH.totalWinView.show(HTHWinConfig.getWinConfig(HTH.model.data.spinWin / HTH.model.gameData.playedBetValue)));
        }
        tl.addLabel("countupCompleted");
        tl.add(() => {
            controller.setSkipCallback();
        });
        if (!isWinBelowStake) {
            tl.to(this, {duration: 0.5});
            if (checkHideCondition) {
                tl.add(HTH.totalWinView.hide(HTHWinConfig.getWinConfig(HTH.model.data.spinWin / HTH.model.gameData.playedBetValue)));
            }
        }

        tl.add(() => {
            HTH.keypadPlugin.setWin(HTH.model.gameData.accumulatedRoundWin, true, HTHHelper.isWinBelowStake());
            controller.finish();
        });
        if (!isWinBelowStake) {
            if (!checkHideCondition) {
                tl.add(HTH.totalWinView.hide(HTHWinConfig.getWinConfig(HTH.model.data.spinWin / HTH.model.gameData.playedBetValue)));
            }
        }

    }
}
